import { Link } from "@components/Link/Link";
import { clsx } from "clsx";
import React from "react";
import { BreadcrumbOutputProps, withBreadcrumb } from "./withBreadcrumb";

import { IconChevronRight } from "@bared/ui";

export const Crumbs = (props: any) => (
  <nav
    {...props}
    className={clsx(
      props.className,
      "flex flex-wrap items-center justify-start text-caption",
      props.float
        ? "mx-auto pb-mini pt-midi md:max-w-2xl md:px-maxi md:pb-midi md:pt-maxi xl:px-tera"
        : "absolute left-[26px] top-midi z-10 md:top-maxi xl:left-maxi",
    )}
  />
);

export const CrumbList = ({ children }: { children: React.ReactNode }) => (
  <ul className="flex pb-micro">{children}</ul>
);
export const CrumbListItem = ({ children }: { children: React.ReactNode }) => (
  <li className="flex">{children}</li>
);
export const Crumb = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "capitalize",
      props.pointer && "cursor-pointer border-b",
    )}
  />
);

export const CrumbLink = (props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "capitalize",
      props.pointer && "cursor-pointer border-b",
    )}
  />
);

export const Breadcrumb = withBreadcrumb(
  ({ paths, float }: BreadcrumbOutputProps) => (
    <Crumbs float={float} data-testid="breadcrumb">
      <CrumbList>
        {paths.map(({ title, url }, index) => (
          <CrumbListItem key={title}>
            {index > 0 && <IconChevronRight className="mx-micro w-[6px]" />}
            {url ? (
              <CrumbLink to={url} pointer={true} title={title}>
                {title}
              </CrumbLink>
            ) : (
              <Crumb>{title}</Crumb>
            )}
          </CrumbListItem>
        ))}
      </CrumbList>
    </Crumbs>
  ),
);
